module.exports = "/_next/static/images/default-product-image-6a863f50371d8b8429ef23d4d657fc37.png";